module.exports = __webpack_public_path__ + "img/gj-icon.9b0ce656.png";